
export const Jupyter = () => {
    return (
        <iframe height={"100%"} width={"100%"} style={{border:"none"}}
                src={"/jupyter"} title={"Jupyter Notebooks"} />
    )
}